/**
 * Navigation utility for SPA navigation outside of React components
 * This allows navigation from interceptors and other non-component code
 */

let navigateFunction = null;

/**
 * Set the navigate function from React Router
 * Should be called from App component or a component that has access to useNavigate
 */
export const setNavigate = (navigate) => {
	navigateFunction = navigate;
};

/**
 * Navigate to a path (SPA navigation)
 * Falls back to window.location if navigate function is not set
 */
export const navigateTo = (path) => {
	if (navigateFunction) {
		navigateFunction(path);
	} else {
		// Fallback: dispatch custom event that App can listen to
		window.dispatchEvent(new CustomEvent('spa-navigate', { detail: { path } }));
	}
};

/**
 * Navigate to login page (SPA navigation)
 */
export const navigateToLogin = () => {
	navigateTo('/login');
};

/**
 * Get the dashboard path based on user role
 * @param {string} tenantId - The tenant identifier
 * @param {string} role - The user's role
 * @returns {string} The dashboard path for the user's role
 */
export const getDashboardPath = (tenantId, role) => {
	switch (role) {
		case 'STARTUP':
		case 'ENTREPRENEUR':
			return `/${tenantId}/startup/dashboard`;
		case 'INVESTOR':
			return `/${tenantId}/investor/dashboard`;
		case 'INVESTOR_NETWORK':
			return `/${tenantId}/investor-network`;
		case 'EVENT_ORGANIZER':
			return `/${tenantId}/organizer/dashboard`;
		case 'VIEWER':
			return `/${tenantId}/viewer/dashboard`;
		case 'MANAGEMENT':
			return `/${tenantId}/investor-network`;
		case 'ADMIN':
		case 'TENANT_ADMIN':
		default:
			return `/${tenantId}/dashboard`;
	}
};

